import { useEffect, useState, type ReactNode } from 'react'
import { readTheme, ThemeContext, themeStorageKey, type Theme } from '@/lib/theme'

export function ThemeProvider({
  children,
  defaultTheme = 'light',
}: {
  children: ReactNode
  defaultTheme?: Theme
}) {
  const [theme, setThemeState] = useState<Theme>(() => readTheme(defaultTheme))

  useEffect(() => {
    const root = document.documentElement
    root.classList.remove('light', 'dark')
    root.classList.add(theme)
  }, [theme])

  function setTheme(nextTheme: Theme) {
    try {
      localStorage.setItem(themeStorageKey, nextTheme)
    } catch {
      // Keep the in-memory preference when storage is blocked.
    }
    setThemeState(nextTheme)
  }

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>
}
